import { render, staticRenderFns } from "./ButtonMnemonicWord.vue?vue&type=template&id=509dc730&scoped=true"
import script from "./ButtonMnemonicWord.vue?vue&type=script&lang=js"
export * from "./ButtonMnemonicWord.vue?vue&type=script&lang=js"
import style0 from "./ButtonMnemonicWord.vue?vue&type=style&index=0&id=509dc730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509dc730",
  null
  
)

export default component.exports